import { FC } from "react";

interface MapIconSVGProps {
    className?: string;
    strokeWidth?: string;
}

const MapIconSVG: FC<MapIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M15 5.76224C14.6897 5.76224 14.3836 5.69002 14.106 5.55131L9.894 3.44531C9.6164 3.30659 9.31033 3.23438 9 3.23438M15 5.76224C15.3103 5.76224 15.6164 5.69002 15.894 5.55131L19.553 3.72131C19.7056 3.64507 19.8751 3.60912 20.0455 3.61688C20.2159 3.62463 20.3814 3.67585 20.5265 3.76564C20.6715 3.85543 20.7911 3.98082 20.874 4.12989C20.9569 4.27896 21.0003 4.44675 21 4.61731V17.3813C20.9999 17.567 20.9481 17.7489 20.8505 17.9068C20.7528 18.0647 20.6131 18.1923 20.447 18.2753L15.894 20.5523C15.6164 20.691 15.3103 20.7632 15 20.7632M15 5.76224V20.7632M15 20.7632C14.6897 20.7632 14.3836 20.691 14.106 20.5523L9.894 18.4463C9.6164 18.3076 9.31033 18.2354 9 18.2354C8.68967 18.2354 8.3836 18.3076 8.106 18.4463L4.447 20.2763C4.29436 20.3526 4.12473 20.3885 3.95426 20.3807C3.78379 20.3729 3.61816 20.3216 3.47312 20.2317C3.32808 20.1418 3.20846 20.0163 3.12565 19.8671C3.04284 19.7179 2.99958 19.55 3 19.3793V6.61631C3.0001 6.43065 3.05189 6.24868 3.14956 6.09078C3.24722 5.93289 3.38692 5.8053 3.553 5.72231L8.106 3.44531C8.3836 3.30659 8.68967 3.23438 9 3.23438M9 3.23438V18.2343"
                stroke="currentColor"
                strokeWidth={props.strokeWidth || "2"}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default MapIconSVG;
